import { useRef, } from 'react';
import BaseFilesGroup, { BaseFilesGroupProps } from '../../utilsTsx/components/files/BaseFilesGroup';
import systematic from '../../config/systematic';

const FilesGroup = (props: any) => {
    const ref = useRef<any>(undefined);
    const extendProps: BaseFilesGroupProps = {
        defaultService: systematic.bmService
    }

    return (
        <>
            <BaseFilesGroup {...extendProps} ref={ref} />
        </>
    )
}

export default FilesGroup;